import { CONFIG } from "../core/config";

export function initScroll() {
	const onScroll = () => {
		const scrollTop = window.scrollY;

		document.body.classList.toggle(
			"minimize",
			scrollTop > CONFIG.scrollThreshold
		);

		const backTop = document.querySelector(".back-to-top");
		if (backTop) {
			backTop.classList.toggle("show", scrollTop > 300);
		}
	};

	window.addEventListener("scroll", throttle(onScroll, 100));


}

export function handleScroll() {
	const scrollTop = window.scrollY;

	// Header minimize
	document.body.classList.toggle(
		"minimize",
		scrollTop > CONFIG.scrollThreshold
	);

	const backTop = document.querySelector(".back-to-top");

	if (backTop) {
		backTop.classList.toggle("show", scrollTop > 300);
	}

	if (backTop) {
		backTop.addEventListener("click", (e) => {
			e.preventDefault();

			window.scrollTo({
				top: 0,
				behavior: "smooth",
			});
		});
	}
}